import React from 'react';
import styled from 'styled-components';
import { EuiButton, EuiIcon } from '@elastic/eui';
import Header from '../../../components/header/Header';

const ErrorStateStyled = styled.section`
  width: min(720px, calc(100% - 28px));
  margin: 40px auto;
  text-align: center;

  .icon {
    color: #f9be49;
    margin-bottom: 12px;
  }

  h1 {
    font-size: 24px;
    margin: 0 0 8px;
  }

  p {
    color: rgba(255, 255, 255, 0.62);
    line-height: 1.5;
    margin: 0 0 18px;
  }
`;

const MonitorLoadError = ({ onRetry }) => (
    <>
        <Header/>
        <ErrorStateStyled role="alert">
            <div className="icon"><EuiIcon type="alert" size="l"/></div>
            <h1>Could not load monitor</h1>
            <p>The monitor list is temporarily unavailable.</p>
            <EuiButton iconType="refresh" onClick={ onRetry } fill>
                Retry
            </EuiButton>
        </ErrorStateStyled>
    </>
);

export default MonitorLoadError;
